import React from 'react';
import classNames from 'classnames';
import './Search.scss';
import Icon from '../Icon';

const Search = ({ size, theme, ...props }) => (
  <div
    className={
      classNames(
        'search',
        {
          [`search--${theme}`]: theme,
          [`search--${size}`]: size,
        }
      )
    }
  >
    <input
      type="text"
      className="search__control"
      {...props}
    />
    <div className="search__icon">
      <Icon
        weight="solid"
        glyph="search"
      />
    </div>
  </div>
);

export default Search;
